import React from 'react';
import { withBreakpoint } from '../../enhancers';

const BookmakersPage = () => <div id="js-bs-bookmakersPage" />;

const BookmakersPageContainer = withBreakpoint(BookmakersPage);

export default BookmakersPageContainer;
